//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from '../../components/Table/Table.vue'
import TableCellObject from '../../components/Table/TableCellObject.vue'
import ReportReworksRemarks from './ReportReworksRemarks.vue'
import { convertTime, formatTrueFalse } from '../../components/helpers.js'

export default {
  components: {
    Table,
    TableCellObject,
    ReportReworksRemarks
  },
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      columns: [{
        name: 'reason',
        label: 'Причина',
        field: 'reason',
        align: 'left'
      },
      {
        name: 'user',
        label: 'Инициатор',
        field: 'user',
        align: 'left',
        columnFormat: 'object',
        columnObjectType: 'employee',
        columnObjectNameProp: 'fio'
      },
      {
        name: 'assignee',
        label: 'Ответственный',
        field: 'assignee',
        align: 'left',
        columnFormat: 'object',
        columnObjectType: 'employee',
        columnObjectNameProp: 'fio'
      },
      {
        name: 'time',
        label: 'Дата/время создания',
        field: 'time',
        align: 'left',
        format: convertTime
      },
      {
        name: 'completeTime',
        label: 'Дата/время завершения',
        field: 'completeTime',
        format: convertTime,
        align: 'left'
      },
      {
        name: 'deferralTime',
        label: 'Срок доработки',
        field: 'deferralTime',
        align: 'left',
        format: (value) => value ? this.convertTime(value) : ''
      },
      {
        name: 'overdue',
        label: 'Просрочено',
        field: (row) => this.getOverdueValue(row),
        align: 'center'
      },
      {
        name: 'remarks',
        label: 'Есть замечания',
        field: (row) => !!(row.remarks && row.remarks.length),
        format: formatTrueFalse,
        align: 'center'
      }]
    }
  },
  methods: {
    convertTime: convertTime,
    getOverdueValue: function (row) {
      const value = row.deferralTime != null ? row.overdue : null
      return value === true ? 'Да' : value === false ? 'Нет' : ''
    },
    onRowClick: function (bodyProps) {
      if (bodyProps.row.remarks && bodyProps.row.remarks.length) {
        bodyProps.expand = !bodyProps.expand
      }
    }
  }
}

